"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateMoneyText = exports.OnHouseRewardCollectClick = exports.OnHouseBuilt = exports.platform = exports.isSimulated = void 0;
var builders_1 = require("./builders");
var lib_1 = require("./lib/lib");
var data_1 = require("./data");
var shop_1 = require("./shop");
require("./css/styles.scss");
var rendering_1 = require("./rendering");
var confetti_1 = require("./lib/confetti");
var settings_1 = require("./settings");
var offlineIncome_1 = require("./offlineIncome");
var math_1 = require("./lib/math");
var simulator_1 = require("./simulator");
var url_1 = require("./lib/url");
var rewardedPopup_1 = require("./rewardedPopup");
var deviceDetection_1 = require("./lib/deviceDetection");
var color_1 = require("./lib/color");
exports.isSimulated = (0, url_1.getQueryString)("simulator") === "true";
exports.platform = "crazygames";
if (window.location.origin.endsWith("yandex.net")) {
    exports.platform = "yandex";
}
if (window.location.origin.endsWith("apps.fbsbx.com")) {
    exports.platform = "fb";
}
console.log("Running on: ".concat(exports.platform));
var moneyElement = document.querySelector("#money");
var houseFinishPopupElement = document.querySelector("#house-finish-popup");
var shopElement = document.querySelector("#shop");
var houseFinishReward = document.querySelector("#house-finish-reward");
var clickTip = document.querySelector("#click-tip");
var loadingOverlay = document.querySelector("#loading-overlay");
// called when crazysdk is initialized
var startGame = function () { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, window.CrazyGames.SDK.init()];
            case 1:
                _a.sent();
                return [4 /*yield*/, (0, data_1.LoadGameData)()];
            case 2:
                _a.sent();
                (0, shop_1.BuildShop)();
                (0, builders_1.StartBuilders)();
                (0, rendering_1.RenderFromScratch)();
                (0, settings_1.BuildSettings)();
                (0, offlineIncome_1.CheckOfflineIncome)(new Date().getTime() - data_1.GameData.lastOnlineMs);
                (0, rewardedPopup_1.InitRewardedPopup)();
                loadingOverlay.remove();
                document.querySelector("#house-finish-reward-button").addEventListener("click", function () { return (0, exports.OnHouseRewardCollectClick)(); });
                document.addEventListener("keyup", function (e) {
                    if (e.code === "Enter" && houseFinished) {
                        (0, exports.OnHouseRewardCollectClick)();
                    }
                });
                houseFinishPopupElement.style.display = "none";
                document.addEventListener("click", function (e) {
                    if (!e.target.classList.contains("clickable"))
                        return;
                    PlaceBrick();
                });
                // if the player comes back to game session and he did not start a new house, but the current house is completed
                if (data_1.GameData.placedBricks >= data_1.HouseData.totalBricks) {
                    (0, exports.OnHouseBuilt)();
                }
                setInterval(exports.UpdateMoneyText, 300);
                SetBackgroundColor();
                clickTip.innerHTML = "<img src='./img/click.png'/>" + ((0, deviceDetection_1.isMobile)() ? "Tap to place bricks" : "Click to place bricks");
                setTimeout(function () {
                    clickTip.remove();
                }, 7500);
                setInterval(function () {
                    (0, shop_1.RefreshShopItemButtons)();
                }, 1000);
                if (exports.isSimulated) {
                    (0, simulator_1.StartSimulation)();
                    if ((0, url_1.getQueryString)("manyMoney") === "true")
                        alert("Simulator started with many money!");
                    if ((0, url_1.getQueryString)("dontSaveDataIHBTestParam") !== "true")
                        alert("Simulator started without save data disabled!");
                }
                return [2 /*return*/];
        }
    });
}); };
var SetBackgroundColor = function () {
    document.querySelector("body").style.backgroundColor = data_1.HouseData.colorTheme.skyColor;
    document.querySelector("#ground").style.backgroundColor = (0, color_1.darken)(-10, data_1.HouseData.colorTheme.skyColor);
    document.querySelector(".management").style.backgroundColor = (0, color_1.darken)(-10, data_1.HouseData.colorTheme.skyColor);
};
var PlaceBrick = function () {
    (0, lib_1.AddBricks)((0, lib_1.CalcBricksPerClick)());
};
var houseFinished = false;
var nextMidgameAd = new Date().getTime() + 3 * 60 * 1000; // next video add 3 minutes after game start
var OnHouseBuilt = function () {
    if (houseFinished)
        return;
    houseFinished = true;
    (0, confetti_1.playConfetti)();
    shopElement.style.display = "none";
    houseFinishPopupElement.style.display = "flex";
    houseFinishReward.innerHTML = "".concat((0, math_1.FormatNumber)((0, lib_1.CalcHouseReward)()));
    (0, rendering_1.DrawDecorations)();
};
exports.OnHouseBuilt = OnHouseBuilt;
var StartNextHouse = function () {
    data_1.GameData.placedBricks = 0;
    data_1.GameData.seed = new Date().getTime().toString();
    (0, data_1.RefreshHouseData)();
    SetBackgroundColor();
    (0, rendering_1.RenderFromScratch)();
    houseFinished = false;
    (0, data_1.SaveGameData)();
};
var OnHouseRewardCollectClick = function () {
    shopElement.style.display = "flex";
    houseFinishPopupElement.style.display = "none";
    data_1.GameData.money += (0, lib_1.CalcHouseReward)();
    (0, exports.UpdateMoneyText)();
    StartNextHouse();
    (0, shop_1.RefreshShopItemButtons)();
    if (new Date().getTime() > nextMidgameAd && !exports.isSimulated && !rewardedPopup_1.PremiumIsActive) {
        var callbacks = {
            adFinished: function () { return console.log("End midgame ad (callback)"); },
            adError: function (error) { return console.log("Error midgame ad (callback)", error); },
            adStarted: function () { return console.log("Start midgame ad (callback)"); },
        };
        window.CrazyGames.SDK.ad.requestAd("midgame", callbacks);
        nextMidgameAd = new Date().getTime() + 4 * 60 * 1000; // next video add 4 minutes after the prev one
    }
};
exports.OnHouseRewardCollectClick = OnHouseRewardCollectClick;
var UpdateMoneyText = function () {
    moneyElement.innerHTML = "".concat((0, math_1.FormatNumber)(Math.floor(data_1.GameData.money)));
};
exports.UpdateMoneyText = UpdateMoneyText;
startGame();
